import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SrText from 'client/components/SrText';

import SrModalV2, { MODAL_THEME_FIXED_FOOTER_BUTTON } from 'client/components/SrModalV2/SrModalV2';
import { SR_BUTTON_THEME_ADOBE_BLUE } from 'client/components/SrButton/SrButton';
import SrBox from 'client/components/SrBox';

const initialState = {
  showMessage: false,
};

class SrPetScreeningLinkModal extends Component {
  static propTypes = {
    partner: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = initialState;
  }

  render() {
    const { partner, onClose, petCount } = this.props;

    if (!partner.petScreeningUrl) {
      return null;
    }

    const noPets = petCount === 0;

    return (
      <SrModalV2
        theme={MODAL_THEME_FIXED_FOOTER_BUTTON}
        onClose={onClose}
        contentPadding="28px 0 30px 0"
        buttonText={noPets ? 'Create your PetScreening profile' : 'Finish PetScreening Here'}
        buttonTheme={SR_BUTTON_THEME_ADOBE_BLUE}
      >
        <SrBox>
          <SrBox padding="0 32px">
            <SrBox marginTop="48px" />
            <SrText
              font="greycliff"
              size="30"
              lineHeight="36px"
              weight="800"
              display="block"
              color="blueGreycliff"
              paddingBottom="25px"
            >
              {noPets
                ? "You don't have a pet but still need to create a profile on PetScreening.com"
                : 'Verify Pets on PetScreening'}
            </SrText>
            <SrBox marginTop="4px" />
            {noPets ? (
              <SrText
                font="greycliff"
                size="22"
                lineHeight="25px"
                weight="400"
                display="block"
                paddingBottom="15px"
              >
                The property owner&nbsp;
                <SrText weight="800" font="greycliff" size="22" lineHeight="25px">
                  requires that applicants create an account on petscreening.&nbsp;
                </SrText>
                There&nbsp;
                <SrText weight="800" font="greycliff" size="22" lineHeight="25px">
                  will not be a fee&nbsp;
                </SrText>
                since you do not have a pet.
              </SrText>
            ) : (
              <div>
                <SrText
                  font="greycliff"
                  size="22"
                  lineHeight="25px"
                  weight="400"
                  display="block"
                  paddingBottom="15px"
                >
                  The property owner&nbsp;
                  <SrText weight="800" font="greycliff" size="22" lineHeight="25px">
                    requires that applicants create an account&nbsp;
                  </SrText>
                  on petscreening.
                </SrText>
                <SrText
                  font="greycliff"
                  size="22"
                  lineHeight="25px"
                  weight="400"
                  display="block"
                  paddingBottom="15px"
                >
                  There is a $25 or $20 per pet fee depending on the payment method. Sunroom does
                  not make money from this fee. Complete the "Assistance Animals' pet screening form
                  for your emotional support or service animals (ESA). There is no charge for ESA
                  screening.
                </SrText>
              </div>
            )}
            <SrText font="greycliff" size="22" lineHeight="25px" weight="400" marginTop="15px">
              <SrText weight="800" font="greycliff" size="22" lineHeight="25px">
                Forward&nbsp;
              </SrText>
              your completed profile to&nbsp;
              <SrText weight="800" font="greycliff" size="22" lineHeight="25px">
                leasing@sunroomrentals.com
              </SrText>
            </SrText>
          </SrBox>
        </SrBox>
      </SrModalV2>
    );
  }
}

SrPetScreeningLinkModal.displayName = 'SrPetScreeningLinkModal';

export default SrPetScreeningLinkModal;
